import { render, staticRenderFns } from "./SearchPlate.vue?vue&type=template&id=8aeeb12c&scoped=true"
import script from "./SearchPlate.vue?vue&type=script&lang=js"
export * from "./SearchPlate.vue?vue&type=script&lang=js"
import style0 from "./SearchPlate.vue?vue&type=style&index=0&id=8aeeb12c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aeeb12c",
  null
  
)

export default component.exports